import {gql} from "@apollo/client";

export const ACTIVE_PLAYERS_QUERY = gql`
  query ActivePlayers($game_code: String!) {
    activePlayers(game_code: $game_code) {
      game_code
      players {
        id
        user_id
        game_id
        status
      }
      player_contents {
        id
        player_id
        content
        player_feedbacks {
          id
          player_content_id
          type
          feedback
        }
        current_mark
        current_bonus_points
      }
      users {
        id
        code
        name
      }
    }
  }
`;

export const GAME_STATUS_QUERY = gql`
  query GameStatus($game_code: String!) {
    gameStatus(game_code: $game_code) {
      status
      game_code
      game {
        id
        game_code
        status
        question
        game_time
        end_time
        overall_performance
        average_word_count
      }
    }
  }
`;

export const PLAYER_CONTENT_FEEDBACK_GENERATED_MUTATION = gql`
  mutation PlayerContentFeedbackGenerated($game_code: String!, $user_code: String!) {
    playerContentFeedbackGenerated(game_code: $game_code, user_code: $user_code) {
      game_code
      user_code
    }
  }
`;

export const GAME_INSIGHTS_GENERATED_MUTATION = gql`
  mutation GameInsightsGenerated($game_code: String!) {
    gameInsightsGenerated(game_code: $game_code) {
      game_code
      game {
        id
        game_code
        status
        question
        game_time
        end_time
        overall_performance
        average_word_count
      }
    }
  }
`;

export const UPDATE_GAME_STATUS_MUTATION = gql`
  mutation UpdateGameStatus($game_code: String!, $status: GameStatus!) {
    updateGameStatus(game_code: $game_code, status: $status) {
      status
      game_code
      game {
        id
        game_code
        status
        question
        game_time
        end_time
        overall_performance
        average_word_count
      }
    }
  }
`;

export const JOIN_GAME_MUTATION = gql`
  mutation JoinGame($game_code: String!, $player_code: String!) {
    joinGame(game_code: $game_code, player_code: $player_code) {
      game_code
      players {
        id
        user_id
        game_id
        status
      }
      users {
        id
        code
        name
      }
    }
  }
`;

export const UPDATE_PLAYER_STATUS_MUTATION = gql`
  mutation UpdatePlayerStatus($game_code: String!, $player_code: String!, $status: PlayerStatus!) {
    updatePlayerStatus(game_code: $game_code, player_code: $player_code, status: $status) {
      game_code
      players {
        id
        user_id
        game_id
        status
      }
      player_contents {
        id
        player_id
        content
        player_feedbacks {
          id
          player_content_id
          type
          feedback
        }
        current_mark
        current_bonus_points
      }
      users {
        id
        code
        name
      }
    }
  }
`;

export const ON_GAME_STATUS_CHANGED_SUBSCRIPTION = gql`
  subscription OnGameStatusChanged($game_code: String!) {
    onGameStatusChanged(game_code: $game_code) {
      status
      game_code
      game {
        id
        game_code
        status
        question
        game_time
        end_time
        overall_performance
        average_word_count
      }
    }
  }
`;

export const ON_PLAYER_JOINED_SUBSCRIPTION = gql`
  subscription OnPlayerJoined($game_code: String!) {
    onPlayerJoined(game_code: $game_code) {
      game_code
      players {
        id
        user_id
        game_id
        status
      }
      player_contents {
        id
        player_id
        content
        player_feedbacks {
          id
          player_content_id
          type
          feedback
        }
        current_mark
        current_bonus_points
      }
      users {
        id
        code
        name
      }
    }
  }
`;

export const ON_PLAYER_CONTENT_FEEDBACK_GENERATED_SUBSCRIPTION = gql`
  subscription OnPlayerContentFeedbackGenerated($game_code: String!, $user_code: String!) {
    onPlayerContentFeedbackGenerated(game_code: $game_code, user_code: $user_code) {
      game_code
      user_code
    }
  }
`;

export const ON_GAME_INSIGHTS_GENERATED_SUBSCRIPTION = gql`
  subscription OnGameInsightsGenerated($game_code: String!) {
    onGameInsightsGenerated(game_code: $game_code) {
      game_code
      game {
        id
        game_code
        status
        question
        game_time
        end_time
        overall_performance
        average_word_count
      }
    }
  }
`;
